import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { closePopupsAction } from 'js/components/common/PopupManager/store/actions';

export const useValidationManager = (type, validationsRef) => {
    const dispatch = useDispatch();

    return useMemo(() => ({
        validationStart: () => validationsRef.current.add(type),
        validationDone: () => {
            validationsRef.current.delete(type);
            dispatch(closePopupsAction({ popups: [type] }));
        },
        isValidationInProcess: () => validationsRef.current.has(type),
        areAllValidationsDone: () => validationsRef.current.size === 0
    }), [dispatch, type, validationsRef]);
};
